import { render, staticRenderFns } from "./standardShippingSettingsModal.vue?vue&type=template&id=cbaec598&scoped=true"
import script from "./standardShippingSettingsModal.vue?vue&type=script&lang=js"
export * from "./standardShippingSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./standardShippingSettingsModal.vue?vue&type=style&index=0&id=cbaec598&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaec598",
  null
  
)

export default component.exports